// TODO: clarify requirements and rewrite using media queries and cover edge cases.
// user agent detection is not a recommended technique for modern web apps.
// It is suggested to use one of the other answers using feature detection and/or media queries.
export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
